import { render, staticRenderFns } from "./LearningVectorHistCard.vue?vue&type=template&id=8180caa4&scoped=true&"
import script from "./LearningVectorHistCard.vue?vue&type=script&lang=ts&"
export * from "./LearningVectorHistCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=8180caa4&prod&scoped=true&lang=css&"
import style1 from "./LearningVectorHistCard.vue?vue&type=style&index=1&id=8180caa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8180caa4",
  null
  
)

export default component.exports